// @flow

import * as React from 'react'

import {
  EditorInput,
  FormGroup,
} from '../../../../../infrastructure/components/Formik'
import { SpacingSettings } from '../shared'

import { useCustomFonts } from '../../../../entities/hooks'

const WebshopTextWidgetSettings = ({ values }) => {
  const [customFonts, isInitialized, { isFetching }] = useCustomFonts()

  const allowFontFamilies = React.useMemo(() => {
    return customFonts.map(font => font.name)
  }, [customFonts])

  if (!isInitialized) {
    return <div>Loading...</div>
  }

  return (
    <div>
      <FormGroup>
        <EditorInput
          allowFontFamilies={allowFontFamilies}
          name="data.text"
          height={300}
        />
      </FormGroup>

      <SpacingSettings />
    </div>
  )
}

export default WebshopTextWidgetSettings
